import React, { useEffect, useState } from "react";
import PdfListModal from "./PdfListModal/PdfListModal";
import "../DropDown.scss";

export default function PdfListButton() {
  const [showModal, setShowModal] = useState(false);
  const [reports, setReports] = useState();
  const URL = `https://www.energymarketprice.com/flink/server/Energy/`;

  async function getList(param) {
    try {
      let result = await fetch(`${URL}${param}`);
      if (!result.ok) return alert("Something Wrong!");
      return await result.json();
    } catch (err) {
      console.log();
    }
  }
  const showPdfList = () => {
    getList("ReadPDF").then((result) => setReports(result));
  };

  useEffect(() => {
    showPdfList();
  }, []);

  const hideModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    setShowModal(true);
  };

  return (
    <div className="pdfListBtn">
      <button className="btn " type="button" onClick={openModal}>
        All reports
      </button>
      {showModal ? (
        <PdfListModal
          reports={reports}
          handleClose={hideModal}
          handleDownload={() => {}}
        />
      ) : null}
    </div>
  );
}
